import { Para, Stack } from 'ui-components';

export default function BuilVersionInfo(): React.ReactElement {
  const commitHash = import.meta.env.VITE_GIT_HASH;
  const shortHash = commitHash?.slice(0, 7) || 'unknown';

  return (
    <Stack>
      <Para align="center">Version: {shortHash}</Para>
    </Stack>
  );
}
